import React, { ReactNode } from 'react';
import {
  Button,
  Column,
  Copy,
  Flex,
  Heading,
  Row,
  Stack,
  SvgX,
} from '@grubhubprod/gh-cookbook-react';
import { useScreenSizes } from 'src/utilities/useScreenSizes';

interface AddGroupsToLocTableHeaderProps {
  onCloseClick: () => void;
  searchInputElement: ReactNode;
  selectAllCheckboxElement: ReactNode;
  numberOfSelectedGroups: number;
  numberOfGroupsInView: number;
  numberOfTotalGroups: number;
}

export const AddGroupsToLocTableHeader: React.FC<AddGroupsToLocTableHeaderProps> =
  ({
    onCloseClick,
    searchInputElement,
    numberOfSelectedGroups,
    numberOfGroupsInView,
    numberOfTotalGroups,
    selectAllCheckboxElement,
  }) => {
    const { isDesktop } = useScreenSizes();

    return (
      <>
        <Stack y="sm">
          <Button
            variant="tertiary"
            type="button"
            onClick={onCloseClick}
            className="removeButtonPadding"
          >
            <SvgX size="24px" />
          </Button>
        </Stack>

        <Stack y="sm">
          <Heading variant="h1">Assign groups</Heading>
        </Stack>

        <Stack y="sm">{searchInputElement}</Stack>

        <Stack y="sm">
          <Flex justifyContent="space-between">
            <Copy
              variant="body"
              color="secondaryText"
            >{`${numberOfSelectedGroups} selected`}</Copy>

            <Copy
              variant="body"
              color="secondaryText"
            >{`${numberOfGroupsInView} of ${numberOfTotalGroups}`}</Copy>
          </Flex>
        </Stack>

        <Row>
          <Column phone={1}>{selectAllCheckboxElement}</Column>

          <Column phone={11}>
            {isDesktop ? (
              <Row>
                <Column desktop={6}>
                  <Copy variant="body" color="secondaryText">
                    Name
                  </Copy>
                </Column>
                <Column desktop={6}>
                  <Copy variant="body" color="secondaryText">
                    No. of people
                  </Copy>
                </Column>
              </Row>
            ) : (
              <Column tablet={6} phone={6}>
                <Copy variant="body" color="secondaryText">
                  Name, No. of people
                </Copy>
              </Column>
            )}
          </Column>
        </Row>
      </>
    );
  };
